/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Reassign_OrgInputs */

const cs_settings_teams_reassign_org = /** @type {(inputs: Settings_Teams_Reassign_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez týmu — celá organizace`)
};

const en_settings_teams_reassign_org = /** @type {(inputs: Settings_Teams_Reassign_OrgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No team — organization-wide`)
};

/**
* | output |
* | --- |
* | "No team — organization-wide" |
*
* @param {Settings_Teams_Reassign_OrgInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_reassign_org = /** @type {((inputs?: Settings_Teams_Reassign_OrgInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Reassign_OrgInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_reassign_org(inputs)
	return cs_settings_teams_reassign_org(inputs)
});